<template>
  <div class="importStaffStepTwo">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm {{ dataImportCurrent.length }} lead<br /></h1>
      <p class="text-primary font-size-16">{{ fileName }}</p>
      <div class="float-right">
        <router-link
          class="f12 font-medium btn btn-outline-secondary mr-1"
          :to="`/import-file-lead`"
          >Chọn lại</router-link
        >
      </div>
    </div>
    <!-- End Breadcrumb Area -->
    <div
      v-if="countItemSuccess.length > 0"
      class="alert alert-success alert-dismissible fade show"
      role="alert"
    >
      <strong>Thành công: {{ countItemSuccess }}</strong
      ><br />
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="alert alert-warning alert-dismissible fade show" role="alert">
      <strong>Lỗi: {{ countItemErr }}</strong>
      <br />
      Vui lòng kiểm tra bản ghi lỗi được bôi màu đỏ và thực hiện import lại những bản ghi lỗi
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="card pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="box-view">
          <div class="box-table table-responsive">
            <!-- <div class="box-header">
                            Số lượng : <strong class="text-primary">1000</strong>
                        </div> -->
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-center" width="50">STT</th>
                  <th scope="col" class="text-center">Tên cửa hàng</th>
                  <th scope="col" class="text-center">Email</th>
                  <th scope="col" class="text-center">Số điện thoại</th>
                  <th scope="col" class="text-center">Họ tên người đại diện</th>
                  <th scope="col" class="text-center">Địa chỉ</th>
                  <th scope="col" class="text-center">Tỉnh/Thành phố</th>
                  <th scope="col" class="text-center">Quận/huyện</th>
                  <th scope="col" class="text-center">Mức độ</th>
                  <th scope="col" class="text-center">Nguồn tạo</th>
                  <th scope="col" class="text-center">Loại CTV</th>
                  <th scope="col" class="text-center">Ngành nghề</th>
                  <th scope="col" class="text-center">Ghi chú</th>
                  <th scope="col" class="text-center text-danger">Lỗi</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in dataImportCurrent" :key="index">
                <tr
                  v-bind:class="[
                    item.descriptionValidate !== ''
                      ? 'table-row bg-danger text-light'
                      : 'table-row',
                  ]"
                >
                  <td align="center">{{ index + 1 }}</td>
                  <td align="center">
                    <b>{{ item.merchantName }}</b>
                  </td>
                  <td align="center">{{ item.email }}</td>
                  <td align="center">{{ item.mobile }}</td>
                  <td align="center">{{ item.representativeName }}</td>
                  <td align="center">{{ item.address }}</td>
                  <td align="center">{{ item.city }}</td>
                  <td align="center">{{ item.district }}</td>
                  <td align="center">{{ item.rating }}</td>
                  <td align="center">{{ item.source }}</td>
                  <td align="center">{{ item.ctvType }}</td>
                  <td align="center">{{ item.mcc }}</td>
                  <td align="center">{{ item.note }}</td>
                  <td align="center">{{ item.descriptionValidate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        dataImportCurrent: [],
        dataErrCurrent: [],
        countItemErr: null,
        countItemSuccess: null,
      }
    },

    created() {
      this.dataImportCurrent = [...this.dataImport]
      this.dataErrCurrent = [...this.dataErr]

      if (this.dataErrCurrent && this.dataErrCurrent.length > 0) {
        this.dataImportCurrent.map((elmDataImport, indexIP) => {
          this.dataErrCurrent.map((elmErr, indexER) => {
            if (elmErr.lineError === indexIP + 3) {
              elmDataImport.descriptionValidate = elmErr.message
            }
          })
        })
        this.countItemErr = this.dataImportCurrent.filter((e, i) => e.descriptionValidate).length
        this.countItemSuccess = this.dataImportCurrent.length - this.countItemErr
      }
    },

    computed: {
      ...mapGetters({
        dataImport: 'staff/getDataCacheTableRow',
        dataErr: 'staff/getDataCacheErrTableRow',
        fileName: 'staff/getDataFileNameExcel',
      }),
    },

    methods: {},
  }
</script>

<style scoped></style>
>
